import Store from 'store/store';

const NONE = '-';
const CODE_REDEMPTION_FORM = 'Code Redemption Form';

const fire = (action, cat, label) => {
	if (!window.firePowsterCustomEvent) return;
	window.firePowsterCustomEvent(action, cat, label);
};

Store.on('TRACK_REDEMPTION_OPEN_OVERLAY', () => {
	fire('coderedemption-tooltip', CODE_REDEMPTION_FORM, NONE);
});

Store.on('TRACK_BFID_INPUT', () => {
	fire('coderedemption-bfid-input', CODE_REDEMPTION_FORM, NONE);
});

Store.on('TRACK_REDEEM_CODE_INPUT', () => {
	fire('coderedemption-code-input', CODE_REDEMPTION_FORM, NONE);
});

Store.on('TRACK_REDEMPTION_SUBMIT_CLICK', () => {
	fire('coderedemption-submit', CODE_REDEMPTION_FORM, NONE);
});

Store.on('TRACK_REDEMPTION_FAQ_EXPAND', ({ label }) => {
	fire('textlistitem-click', `${CODE_REDEMPTION_FORM} FAQs`, label);
});

Store.on('TRACK_REDEMPTION_SUBMIT_ERROR', ({ error }) => {
	fire(`coderedemption-${error}`, CODE_REDEMPTION_FORM, NONE);
});

Store.on('TRACK_REDEMPTION_SUBMISSION_SUCCESS', () => {
	fire('coderedemption-success', CODE_REDEMPTION_FORM, NONE);
});